var $6f40c3a58f594b58$exports = {};
const $6f40c3a58f594b58$var$name = document.querySelector('.name-input');
const $6f40c3a58f594b58$var$phone = document.querySelector('.phone-input');
const $6f40c3a58f594b58$var$button = document.querySelector('.btn');
const $6f40c3a58f594b58$var$contact = document.querySelector('.contact-list');
$6f40c3a58f594b58$var$button.onclick = ()=>{
    const li = document.createElement('li');
    li.innerHTML = `
        <span><strong>${$6f40c3a58f594b58$var$name.value}</strong>: ${$6f40c3a58f594b58$var$phone.value}</span>
        <button class="delete-btn">\u{412}\u{438}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{438}</button>
    `;
    li.querySelector('.delete-btn').onclick = ()=>{
        li.remove();
    };
    $6f40c3a58f594b58$var$contact.appendChild(li);
    // Очищення інпутів
    $6f40c3a58f594b58$var$name.value = '';
    $6f40c3a58f594b58$var$phone.value = '';
};


//# sourceMappingURL=goit-js-hw-2-9.4ee1179f.js.map
